import config from 'const/config'
import sessionKeys from 'const/sessionKeys'
import { FormState } from 'typings'
import api from './requestBuilder'

const caseCreation = async (recaptchaToken: string, otpToken: string) => {
  const endpoint = '/v1/credit/accounts/ccpa/consumer-case-creation'
  const params = {
    recaptchaToken: recaptchaToken || sessionStorage.getItem(sessionKeys.recaptchaToken),
    jwtToken: otpToken,
    channelId: config.CHANNEL_ID
  }
  return await api.post(endpoint, params)
}

export default caseCreation
